import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachAutomationLayout } from "src/pages/CoachAutomationLayout";
import { automationQueryOptions } from "src/queries/automations";

export const Route = createFileRoute("/_auth/_coach/automations/$automationId")(
  {
    component: CoachAutomationLayout,
    ssr: true,
    shouldReload: false,
    async loader({ context, params }) {
      return await loaderHandler(async () => {
        const automation = await context.queryClient.query({
          ...automationQueryOptions(params.automationId),
          staleTime: "static",
        });

        return {
          data: null,
          breadcrumb: {
            id: automation.id,
            label: automation.name,
            href: `/automations/${automation.id}`,
          },
        };
      });
    },
  },
);
